function storageKey(id: string): string {
  return `urgent-banner-dismissed:${id}`
}

/** Persist dismiss across reloads/tabs (admin “Fermable” = durable until message id changes). */
export function readUrgentMessageDismissed(id: string): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (window.localStorage.getItem(storageKey(id)) === '1') {
      return true
    }
    // Migrate legacy session-only dismiss so an already-closed banner stays closed.
    if (window.sessionStorage.getItem(storageKey(id)) === '1') {
      window.localStorage.setItem(storageKey(id), '1')
      window.sessionStorage.removeItem(storageKey(id))
      return true
    }
    return false
  } catch {
    return false
  }
}

export function writeUrgentMessageDismissed(id: string): void {
  try {
    window.localStorage.setItem(storageKey(id), '1')
    window.sessionStorage.removeItem(storageKey(id))
  } catch {
    /* storage unavailable */
  }
}
